import Cookies from 'js-cookie';
import Swiper, { Navigation } from 'swiper';
import AOS from 'aos';
import Counter from '../util/Counter';
import Map from '../util/Map';
import Plyr from 'plyr';

export default {
  init() {
    // JavaScript to be fired on all pages

    // Chatbox
    if ($('.js-chatbox').length > 0) {
      if (Cookies.get('everone-chatbox') != 'closed') {
        $('.js-chatbox').delay(2000).fadeIn();
        $('.js-chatbox').find('.js-close').on('click', function () {
          $(this).parent('.js-chatbox').fadeOut();
          Cookies.set('everone-chatbox', 'closed');
        });
      }
    }

    // Scroll
    let scrollpos = window.scrollY;

    const body = document.querySelector('body');
    const header = document.querySelector('.js-site-header');
    const scrollChange = 100;

    const addClassOnScroll = function () {
      body.classList.add('scrolled');
      header.classList.add('scrolled');
    }
    const removeClassOnScroll = function () {
      body.classList.remove('scrolled');
      header.classList.remove('scrolled');
    }
    window.addEventListener('scroll', function () {
      scrollpos = window.scrollY;

      if (scrollpos >= scrollChange) { addClassOnScroll() } else { removeClassOnScroll() }
    })

    // Responsive nav
    const burgerBtn = document.querySelector('.js-menu');
    burgerBtn.addEventListener('click', function () {
      burgerBtn.classList.toggle('menu-is-opened');
      document.querySelector('.js-site-header').classList.toggle('is-opened');
      // document.querySelector('html').classList.toggle('overflow-hidden');
    });

    // Open submenu
    const menuLinks = document.querySelectorAll('.js-open-submenu');
    menuLinks.forEach(function (m, index) {
      m.onmouseenter = function () {
        if (window.innerWidth >= 1024) {
          this.classList.add('is-active');
        }
      }
      m.onmouseleave = function () {
        if (window.innerWidth >= 1024) {
          this.classList.remove('is-active');
        }
      }
      m.onclick = function () {
        menuLinks.forEach(function (n, i) {
          if (index != i) {
            n.classList.remove('is-active');
          }
        })
        this.classList.toggle('is-active');
      }
    });

    //Modal
    const openModal = document.querySelectorAll('.js-open-modal');

    if (openModal.length > 0) {
      openModal.forEach((el) => {
        el.addEventListener('click', function () {
          const target = el.getAttribute('data-modal');
          const modal = document.getElementById(target);
          modal.classList.remove('hidden');
          let player = null;

          if (modal.querySelector('.js-video')) {
            player = new Plyr(modal.querySelector('.js-video'),
              {
                youtube: { noCookie: true, rel: 0, showinfo: 0, iv_load_policy: 3, modestbranding: 1 },
              });
          }

          const closeModal = modal.querySelector('.js-close-modal');
          closeModal.addEventListener('click', function () {
            modal.classList.add('hidden');
            if (player) {
              player.destroy();
            }
          })
        })
      })
    }


    // Smooth scrolling when clicking on a anchor link
    const anchors = document.querySelectorAll('a[href^="#"]:not([href="#"]');
    anchors.forEach(function (el) {
      el.addEventListener('click', function (e) {
        e.preventDefault();

        // Get target element
        const target = this.hash;

        // Calcul scrollTop
        const offsetTop = document.querySelector(target).offsetTop;
        scroll({
          top: offsetTop - 100,
          behavior: 'smooth',
        });
      });
    });


    // Swiper
    const swipers = document.querySelectorAll('.js-swiper');
    if (swipers.length > 0) {
      swipers.forEach(function (el) {
        const lessCols = el.classList.contains('swiper-small');
        new Swiper(el, {
          modules: [Navigation],
          watchSlidesProgress: true,
          slideVisibleClass: 'active',
          slidesPerView: 1,
          spaceBetween: 20,
          speed: 600,
          breakpoints: {
            640: {
              slidesPerView: 1,
              spaceBetween: 40,
            },
            768: {
              slidesPerView: 2,
              spaceBetween: 40,
            },
            1024: {
              slidesPerView: lessCols ? 1 : 3,
              spaceBetween: 40,
            },
            1280: {
              slidesPerView: lessCols ? 2 : 3,
              spaceBetween: 40,
            },
          },
          navigation: {
            nextEl: '.swiper-navigation-item--prev',
            prevEl: '.swiper-navigation-item--next',
          },
        });
      });
    }

    // Dropdown
    if ($('.js-dropdowns').length > 0) {
      document.querySelectorAll('.js-dropdowns').forEach((e) => {
        const contents = e.querySelectorAll('.js-dropdown');
        let max = 0;
        let total = 0;
        contents.forEach((c) => {
          if (c.querySelector('.js-dropdown__content') && c.querySelector('.js-dropdown__content').clientHeight > max) {
            max = c.querySelector('.js-dropdown__content').clientHeight;
          }
        })
        let titles = e.querySelectorAll('.js-dropdown__title');
        titles.forEach((d) => {
          total += d.clientHeight + 4;
        })
        const dropdownHeight = max + total;
        e.style.minHeight = dropdownHeight + 'px';
      })
    }

    $(document).on('click', '.js-dropdown__title', function () {
      var element = $(this);

      // Reset
      element.parents('.js-dropdowns').find('.js-dropdown__title').not(element).parents('.js-dropdown').removeClass('open');
      element.parents('.js-dropdowns').find('.js-dropdown__title').not(element).attr('aria-expanded', false);
      element.parents('.js-dropdowns').find('.js-dropdown__title').not(element).parents('.js-dropdown').find('.js-dropdown__content').attr('aria-hidden', true);

      // Switch current dropdown
      if (element.parents('.js-dropdown').hasClass('open')) {
        element.parents('.js-dropdown').removeClass('open');
        element.attr('aria-expanded', false);
        element.parents('.js-dropdown').find('.js-dropdown__content').attr('aria-hidden', true);
      } else {
        element.parents('.js-dropdown').addClass('open');
        element.attr('aria-expanded', true);
        element.parents('.js-dropdown').find('.js-dropdown__content').attr('aria-hidden', false);
      }
    });

    // Translate label form
    if ($('.form-element').length > 0) {
      document.querySelectorAll('input').forEach((input) => {
        input.addEventListener('focus', () => {
          input.closest('.form-element').querySelector('label').classList.add('active');
        });
      });
      document.querySelectorAll('input').forEach((input) => {
        input.addEventListener('focusout', () => {
          if (input.value == '') {
            input.closest('.form-element').querySelector('label').classList.remove('active');
          }
        });
      });
      document.querySelectorAll('select').forEach((select) => {
        select.addEventListener('focus', () => {
          select.closest('.form-element').querySelector('label').classList.add('active');
        });
      });
      document.querySelectorAll('select').forEach((select) => {
        select.addEventListener('focusout', () => {
          if (select.value == '') {
            select.closest('.form-element').querySelector('label').classList.remove('active');
          }
        });
      });
      document.querySelectorAll('textarea').forEach((textarea) => {
        textarea.addEventListener('focus', () => {
          textarea.closest('.form-element').querySelector('label').classList.add('active');
        });
      });
      document.querySelectorAll('textarea').forEach((textarea) => {
        textarea.addEventListener('focusout', () => {
          if (textarea.value == '') {
            textarea.closest('.form-element').querySelector('label').classList.remove('active');
          }
        });
      });
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired

    // AOS
    AOS.init({
      duration: 700,
    });

    // Counter
    Counter.initCounter();

    // Offices
    Map.initMap();

    const titles = document.querySelectorAll('h1,h2,h3,h4');
    if (titles.length > 0) {
      titles.forEach(function (item) {
        item.innerHTML = replaceNonBreaking(item.innerHTML);
      });
    }
  },
};


function replaceNonBreaking(text) {
  return text.replace(/ (!|:|\?|…|;|»)/g, '&nbsp;$1').replace('« ', '«&nbsp;');
}
